import { ROUTES } from '../constants/routes'
import { isCertificationService } from './typeGuards'

/**
 * Where a service card points. The certification service has no Contentful content blocks, so it
 * skips the generic service page and opens the start view directly.
 */
export const getServiceLink = (serviceIdentifier: unknown, slug: string | undefined): string =>
  isCertificationService(serviceIdentifier) ? ROUTES.ADMIN_CERTIFICATION : `${ROUTES.ADMIN_SERVICES}/${slug}`
